export default __webpack_public_path__ + "static/media/scene_14.672498e2.mp3";